import type { Category, EventDetails, ProductDetails } from "mws-ts-v2-sdk";

/**
 * Used to trigger a tracking event including entity-specific data only once when an entity is ready.
 */
export const useTrackEventOnce = <
  T extends Category | EventDetails | ProductDetails,
>(
  item: MaybeRefOrGetter<T | undefined>,
  trackFn: (item: T) => void,
) => {
  const isTrackTriggered = ref(false);

  watchEffect(() => {
    if (isTrackTriggered.value) return;

    const itemData = toValue(item);
    if (!itemData) return;

    trackFn(itemData);
    isTrackTriggered.value = true;
  });
};
